import {MoreOutlined} from "@ant-design/icons";
import {Button, Dropdown, Menu, message, Modal} from "antd";
import {useNavigate} from "react-router-dom";
import {useDeleteLiveClass} from "../../../../../react-query-hooks/live-events/live-classes";
import {handleLiveClassLink} from "../../../../../utils/live-class";

const LiveClassCardMenu = ({
  eventId,
  is_co_host,
  hostUsername,
  slug,
  tiny_url,
}: {
  eventId: number;
  is_co_host?: boolean;
  hostUsername?: string;
  slug?: string;
  tiny_url?: string;
}) => {
  const deleteLiveClassQueryMutation = useDeleteLiveClass();
  const navigate = useNavigate();

  const handleDeleteModal = () => {
    Modal.confirm({
      title: `Confirm event deletion`,
      content: (
        <>
          <p>
            Are you sure you want to delete this live event? If there are registered
            attendees, they will be notified of the cancellation and will receive a full
            refund.
            <br />
            <br />
            This action cannot be undone.
          </p>
        </>
      ),
      okText: "Delete & cancel event",
      cancelText: "Exit",
      okType: "danger",
      okButtonProps: {
        size: "small",
        type: "primary",
      },
      cancelButtonProps: {
        size: "small",
        type: "ghost",
      },
      onOk() {
        // if (serviceData.id) {
        // dispatch(deleteServiceById(serviceData.id))
        return new Promise((resolve, reject) => {
          if (eventId) {
            // resolve(console.log(`Trying to delete ${liveClassData.id}`));
            resolve(
              deleteLiveClassQueryMutation.mutate(String(eventId), {
                onSuccess: () => {
                  message.success("The selected event has been deleted successfully!");
                  navigate("/live-classes");
                },
              })
            );
          }
        }).catch(() => message.error("Failed to delete"));
        // };
      },
    });
  };
  const handleViewDetails = () => {
    if (is_co_host && hostUsername && slug) {
      const link = handleLiveClassLink({
        eventId,
        slug: slug,
        tinyUrl: tiny_url,
        username: hostUsername,
        windowNav: true,
      });
      window.open(link, "_blank");
    } else {
      navigate(`/live-classes/edit/${eventId}?activeTab=form`);
    }
  };

  const menu = (
    <Menu
      items={[
        {
          label: <div onClick={handleViewDetails}>View details</div>,
          key: "0",
        },
        {
          label: (
            <div
              onClick={() => navigate(`/live-classes/edit/${eventId}?activeTab=insights`)}
            >
              View attendees
            </div>
          ),
          key: "1",
        },
        {
          label: <div onClick={handleDeleteModal}>Delete</div>,
          danger: true,
          key: "2",
        },
      ]}
    />
  );
  return (
    <>
      <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
        <div
          style={{
            backgroundColor: "transparent",
            color: "#1C1726",
            border: "none",
            boxShadow: "none",
            cursor: "pointer",
          }}
        >
          <MoreOutlined />
        </div>
      </Dropdown>
    </>
  );
};

export {LiveClassCardMenu};
